import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Label, Row, Table} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {IRootState} from 'app/shared/reducers';
import {getEntities} from './followup.reducer';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {IRegion} from "app/shared/model/region.model";
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';

export interface IFollowupProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const Followup = (props: IFollowupProps) => {
  const emptyRegion: IRegion = null
  const {followupList, match, loading, userCountryId} = props;
  const [activeCountry, setActiveCountry] = useState<IRegion>({})
  const [followupsPerCountry, setFollowupPerCountry] = useState([])
  const [selectedEmergencyType, setSelectedEmergencyType] = useState('');
  const [selectedFollowupType, setSelectedFollowupType] = useState('');

  useEffect(() => {
    props.getEntities();
  }, []);

  useEffect(() => {
    const ac = props.countries.find(country => country.id === userCountryId)
    setActiveCountry(ac)
  }, [props.countries, userCountryId]);

  const updateSymptomList = (ac) => {
    setFollowupPerCountry(followupList.filter(followup => followup.countryId && followup.countryId === ac.id))
  }

  useEffect(() => {
    if (followupList && activeCountry) {
      updateSymptomList(activeCountry)
    }
  }, [followupList]);

  const filteredFollowups = followupsPerCountry.filter(followup => {
    const matchesEmergencyType = !selectedEmergencyType || followup.emergencyType === selectedEmergencyType;
    const matchesFollowupType = !selectedFollowupType || followup.followupType === selectedFollowupType;
    return matchesEmergencyType && matchesFollowupType;
  });

  const onCountryChange = (event) => {
    const countryId = event.target.value
    const newActiveCountry = props.countries.find(country => country.id === countryId)
    setActiveCountry(newActiveCountry)
    setSelectedEmergencyType('');
    setSelectedFollowupType('');
    updateSymptomList(newActiveCountry)
  }
  const regCountriesList = props.countries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry?.id;
  })

  return (
    <div>
      <Row>
        <Col md="6">
          <h2 id="followup-heading">Followups</h2>
        </Col>
        <Col md="6">
          {(activeCountry && typeof activeCountry.id !== 'undefined') && (
            <Link to={`${match.url}/new?country_id=${activeCountry.id}`}
                  className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
              <FontAwesomeIcon icon="plus"/>
              &nbsp; Create new Followup
            </Link>
          )}
        </Col>
      </Row>
      <br/>
      <AvForm model={{}}>
        <Row>
          {activeCountry && (
            <Col md="12">
              <AvGroup>
                <Label for="followup-countries">Country</Label>
                <AvInput id="followup-countries" type="select" className="form-control" name="followup-country"
                         value={activeCountry.id} onChange={onCountryChange}>
                  {regCountriesList
                    ? regCountriesList.map(country => (
                      <option value={country.id} key={country.id}>
                        {country.name}
                      </option>
                    ))
                    : null}
                </AvInput>
              </AvGroup>
            </Col>
          )}
          <Col md="6">
            <AvGroup>
              <Label for="followup-followup-type">Followup Type</Label>
              <AvInput
                id="followup-followup-type"
                type="select"
                className="form-control"
                name="followup-followup-type"
                value={selectedFollowupType}
                onChange={e => setSelectedFollowupType(e.target.value)}
              >
                <option value="">All Followup Types</option>
                <option value="MATERNAL">MATERNAL</option>
                <option value="NEONATAL">NEONATAL</option>
              </AvInput>
            </AvGroup>
          </Col>
          <Col md="6">
            <AvGroup>
              <Label for="followup-emergency-type">Emergency Type</Label>
              <AvInput
                id="followup-emergency-type"
                type="select"
                className="form-control"
                name="followup-emergency-type"
                value={selectedEmergencyType}
                onChange={e => setSelectedEmergencyType(e.target.value)}
              >
                <option value="">All Emergency Types</option>
                {Object.values(EmergencyType).map(type => (
                  <option value={type} key={type}>{type}</option>
                ))}
              </AvInput>
            </AvGroup>
          </Col>
        </Row>
      </AvForm>
      <br/>

      <div className="table-responsive">
        {filteredFollowups && filteredFollowups.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th>Followup Type</th>
              <th>Emergency Type</th>
              <th>Followup (English)</th>
              <th>Followup (Local Language)</th>
              <th>Is Alive</th>
              <th>Delivered</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {filteredFollowups.map((followup, i) => (
              <tr key={`entity-${i}`}>
                <td>{followup.followupType}</td>
                <td>{followup?.emergencyType}</td>
                <td>{followup.enFollowup}</td>
                <td>{followup.stFollowup}</td>
                <td>{followup.isAlive ? 'Yes' : 'No'}</td>
                <td>{followup.isDelivered ? 'Yes' : followup.isDelivered === null ? 'Null' : 'No'}</td>
                <td>{followup.isActive ? 'Active' : 'Inactive'}</td>
                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${followup.id}`} color="info" size="sm">
                      <FontAwesomeIcon icon="eye"/> <span className="d-none d-md-inline">View</span>
                    </Button>
                    <Button tag={Link} to={`${match.url}/${followup.id}/edit`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">Edit</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Symptoms found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({followup, authentication}: IRootState) => ({
  followupList: followup.followupList,
  loading: followup.loading,
  countries: followup.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Followup);
